import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { MODEL_API_URL } from "../../../config";
import { ClientModelVariable } from "../types";

export const useClientModelVariables = (
  model_id: number,
  variable_type?: "media" | "external"
) => {
  const variable_query = variable_type ? `?var_type=${variable_type}` : "";
  return useQuery({
    queryKey: ["client", "model", "variables", model_id, variable_type],
    enabled: model_id > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${MODEL_API_URL}/waves-model-manager-api/v1/models/${model_id}/variables${variable_query}`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModelVariable[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
